const isNullOrUndefined = <TValue>(value: TValue) => value === null || value === undefined;

export default isNullOrUndefined;
